<template>
    <div class="vrm-fieldset__item sg-custom-check-and-radio sg-custom-check">
        <label
            class="vrm-fieldset__item__label sg-textfield-label"
            :class="{ 'sg-required': required }"
        >
            <input v-model="value" type="checkbox" />
            <span class="sg-textfield-label-caption">
                <slot name="title">{{ title }}</slot>
            </span>
            <div class="sg-alternative-display">
                <div class="sg-icon-check" />
            </div>
        </label>
        <div v-show="showErrors" class="vrm-form_input-errors">
            <span v-if="errors.includes('required')" class="sg-input-error">
                {{ $t('form.required') }}
            </span>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import VrmToggleCheckmark from '@/vue/components/shared/toggles/VrmToggleCheckmark';
import VrmToggle from '@/vue/components/shared/toggles/VrmToggle';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
@Component({
    components: { VrmToggle, VrmToggleCheckmark },
    inheritAttrs: false,
})
@AngularLocaleBundle('form')
export default class VrmFormCheckbox extends Vue {
    @Prop()
    title;

    @Prop({ type: Boolean, default: false })
    required;

    @Model('input')
    model;

    get value() {
        return this.model;
    }

    set value(newValue) {
        this.$emit('input', newValue);
    }

    touched = false;
    errors = [];

    vrmValidate() {
        this.touched = true;
        this.errors = [];
        if (this.required && !this.value) {
            this.errors.push('required');
            return false;
        }
        return true;
    }

    get showErrors() {
        return this.touched && this.errors.length;
    }
}
</script>
